const storage = {
    not_configured: 'Storage provider is not configured.',
    missing_parameter: 'Missing parameter {{parameter}} for storage provider.',
    upload_error: 'Failed to upload file to the storage provider.',
};
export default Object.freeze(storage);
